import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface Request {
    category: string;
    limit: string;
    page: number;
    searchtxt: string;
}
export type DataListProps = {
    flag: boolean;
    list_no: number;
    bl_no: string;
    subject: string;
    company: string;
    mobile: string;
    w_date: string;
    comment: boolean;
    comment_count: number;
};

export interface ResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleBillInquiry = ({ category, page, limit, searchtxt }: Request): UseQueryResult<ResponseData, Error> => {
    let url = enum_api_uri.get_console_bill.replace(":category", category);
    return useQuery({
        queryKey: ["useGetConsoleBillInquiry", category, page, limit, searchtxt],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    page,
                    limit,
                    search: "all_search",
                    searchtxt,
                },
            });
            return response.data.data;
        },
    });
};
